import React from 'react';

const VideoIcon = ({ id, className, color, styles = {} }) => {
	const colorMap = {
		cdgr: '#5b5855',
		cgrn: '#0C4A34',
		cw: '#FFFFFF',
		cbb: '#3477AC',
	};

	return (
		<div id={id} className={className} style={styles}>
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					d='M17 14.4762L17.356 13.5417L16 13.0251V14.4762H17ZM20.7288 15.8967L20.3728 16.8312V16.8312L20.7288 15.8967ZM20.7288 8.10331L21.0848 9.0378L21.0848 9.0378L20.7288 8.10331ZM17 9.52381H16V10.9749L17.356 10.4583L17 9.52381ZM4 6V6V4C2.89543 4 2 4.89543 2 6H4ZM4 18V6H2V18H4ZM4 18H4H2C2 19.1046 2.89543 20 4 20V18ZM16 18H4V20H16V18ZM16 18V20C17.1046 20 18 19.1046 18 18H16ZM16 14.4762V18H18V14.4762H16ZM21.0848 14.9622L17.356 13.5417L16.644 15.4107L20.3728 16.8312L21.0848 14.9622ZM20 15.7098C20 15.1495 20.5612 14.7627 21.0848 14.9622L20.3728 16.8312C21.1582 17.1304 22 16.5503 22 15.7098H20ZM20 8.29021V15.7098H22V8.29021H20ZM21.0848 9.0378C20.5612 9.23728 20 8.85054 20 8.29021H22C22 7.44971 21.1582 6.86961 20.3728 7.16883L21.0848 9.0378ZM17.356 10.4583L21.0848 9.0378L20.3728 7.16883L16.644 8.58932L17.356 10.4583ZM16 6V9.52381H18V6H16ZM16 6H18C18 4.89543 17.1046 4 16 4V6ZM4 6H16V4H4V6Z'
					fill={`${colorMap[color] || '#B0ACA3'}`}
				/>
			</svg>
		</div>
	);
};

export default VideoIcon;
